import BlockCodeRuntime from '@/components/code/blockCode/BlockCodeRuntime';
import { BlockCodeCorrectAnswer } from '@/models/ActivityProgress';
import { useWorkspace } from '../../edit/BlockCodeElementEdit/WorkspaceForm.hooks';
import { ElementPreviewFactoryProps } from '../ElementPreviewFactory';

function BlockCodeFeedback({ answer }: ElementPreviewFactoryProps) {
  const { solutionWorkspace } = answer as BlockCodeCorrectAnswer;

  const { workspace, setWorkspace } = useWorkspace(solutionWorkspace);
  return (
    <div className="w-11/12">
      <BlockCodeRuntime
        workspace={workspace}
        onWorkspaceChange={setWorkspace}
        readOnly={true}
        className="h-[500px]"
      />
    </div>
  );
}

export default BlockCodeFeedback;
